module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_DE.1230fbe6.txt";